import { MaterialModule } from 'src/app/material/material.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  AccessRightMaintenance,
  AuthGuard,
  BlockPageAuthGuard,
  CanAuthenticationGuard,
} from '../../utils/authguard';
import { MaintenancePageComponent } from './maintenance-page.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

const routes = [
  {
    path: 'maintenance-settings',
    component: MaintenancePageComponent,
    canActivate: [
      CanAuthenticationGuard,
      AccessRightMaintenance,
      AuthGuard,
      BlockPageAuthGuard,
    ],
    //data: { disabled: maintenance.dashboard.isDisabled }
  },
];

@NgModule({
  declarations: [MaintenancePageComponent],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    MaterialModule,
    MatSlideToggleModule,
  ],
  exports: [MaintenancePageComponent],
  providers: [CanAuthenticationGuard],
})
export class MaintenancePageModule {}
